.kdx-team-members {
	text-align: center;
	position: relative;
	margin-bottom: 40px;
	
	.form-control {
		text-align: left;
	}
	.border-bottom { border-bottom: 1px solid #CCC !important; }
	.filters { 
		justify-content: center;
		align-items: flex-end;		
		
		label {
			display: block;
			text-align: left;
			margin-bottom: 5px;
			color: $primary;
			font-weight: 600;
			font-family: $font-family-secondary;
		}
		.or {
			position: relative;
			margin-bottom: 8px;

			.text {
				display: inline-block;
				background: #FFF;
				padding: 0 16px;
				position: relative;
				z-index: 2;
				color: #000;
			}
			&::before {
				content: '';
				background: #707070;
				height: 1px;
				position: absolute;
				top: 50%;
				left: 0;
				width: 100%;
				z-index: 1;
			}
		}
		.clear-filters-wrapper { text-align: left; }		
		.clear-filters {
			@include text-size(15);
			@include line-height(19);
			font-weight: 700;
			font-family: $font-family-secondary;
			text-decoration: none;
			position: relative;
			padding-bottom: 4px;
			margin-bottom: 8px;
			display: inline-block;
			
			&::after {
				content: '';
				position: absolute;
				top: 100%;
				left: 0;
				width: 0;
				height: 1px;
				background: #000;
				transition: width .3s ease-in-out;
			}

			svg {
				@include svg-format(12px, 12px, currentColor);
				margin-right: 5px;
			}
			&:hover, &:focus {
				color: #000;

				&::after { width: 100%; }
			}
		}
	}
	.load-more-btn {
		color: $link-color-primary;
		text-decoration: none;
		@include text-size(21);
		@include line-height(19);
		font-weight: 700;
		position: absolute;
		bottom: -13px;
		padding-bottom: 15px;
		left: 0;
		right: 0;
		z-index: 1;

		svg {
			@include svg-format(14px, 14px, currentColor);
			margin-top: 4px;
			transition: transform .3s ease-in-out;
		}
		&:hover, &:focus {
			color: #000;

			svg { transform: translateY(4px); }
		}
		&.btn { transform: none; }
	}
	&.fade-active {
		max-height: 1068px;
		overflow: hidden;
		transition: all 350ms linear;

		&::after {
			content: '';
			height: 269px;
			width: 100%;
			position: absolute;
			bottom: 0px;
			background: transparent linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%) 0% 0% no-repeat padding-box;
			left: 50%;
			transform: translateX(-50%);
		}

		&.expanded {
			&::after {
				content: normal;
			}
		}
	}

	
}





@include media-breakpoint-down(lg) {
	.kdx-team-members {		
		margin-bottom: 20px;

		.form-control {
			margin-bottom: 15px;
		}
		.filters {

			.or { 
				margin: 16px auto;
				max-width: 105px;
			}
		}
	}
}






@include media-breakpoint-down(sm) {
	.kdx-team-members {
		

		a.btn {
			transform: translate(-50%, 10%);
		}
	
		&.fade-active {
			max-height: 1578px;
		}
		.row.border-bottom {
			border-bottom: none!important;
		}
	}

}